'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _themes = require('../themes'),
    componentTheme = function componentTheme(baseTheme) {
  var _baseTheme$vstui = baseTheme.vstui,
      color = _baseTheme$vstui.color,
      size = _baseTheme$vstui.size,
      transition = _baseTheme$vstui.transition,
      cloud3 = color.cloud.getShade(3),
      black43 = 'rgba(0, 0, 0, 0.43)',
      knobPadding = 4,
      switchKnobDiameterSmall = size.small - 2 * knobPadding,
      switchKnobDiameterMedium = size.medium - 2 * knobPadding,
      switchKnobDiameterLarge = size.large - 2 * knobPadding;
  return (0, _themes.createComponentTheme)(baseTheme, {
    Switch_width_small: knobPadding + 2 * switchKnobDiameterSmall + 'px',
    Switch_width_medium: knobPadding + 2 * switchKnobDiameterMedium + 'px',
    Switch_width_large: knobPadding + 2 * switchKnobDiameterLarge + 'px',
    Switch_backgroundColor_themePrimary_disabled_on: function primaryMain(_ref) {
      var sc = _ref.sc;
      return color.primary.getMainShade({
        backgroundColor: sc.colorBehindButton
      });
    },
    Switch_backgroundColor_off: cloud3,
    Switch_borderColor_off: black43,
    Switch_borderColor_off_active: black43,
    Switch_borderColor_off_focus: black43,
    Switch_borderColor_off_hover: black43,
    Switch_borderRadius: '100px',
    Switch_transitionDuration: transition.duration.shortest,
    SwitchKnob_width_small: switchKnobDiameterSmall + 'px',
    SwitchKnob_width_medium: switchKnobDiameterMedium + 'px',
    SwitchKnob_width_large: switchKnobDiameterLarge + 'px',
    SwitchKnob_translateX_small: 'translateX(' + (knobPadding - 1) + 'px)',
    SwitchKnob_translateX_medium: 'translateX(' + (knobPadding - 1) + 'px)',
    SwitchKnob_translateX_large: 'translateX(' + (knobPadding - 1) + 'px)',
    SwitchKnob_translateX_small_pressed: 'translateX(' + (switchKnobDiameterSmall - 1) + 'px)',
    SwitchKnob_translateX_medium_pressed: 'translateX(' + (switchKnobDiameterMedium - 1) + 'px)',
    SwitchKnob_translateX_large_pressed: 'translateX(' + (switchKnobDiameterLarge - 1) + 'px)'
  });
};

exports.default = componentTheme;